import script from "./Omashu-Experience.vue?vue&type=script&setup=true&lang=js"
export * from "./Omashu-Experience.vue?vue&type=script&setup=true&lang=js"

import "./Omashu-Experience.vue?vue&type=style&index=0&id=6e44af2a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e44af2a"]])

export default __exports__